export const extractDomainFromInput = (text: string): string => {
  // Remove protocol if present
  let domain = text.replace(/^https?:\/\//, '');
  // Remove www. if present
  domain = domain.replace(/^www\./, '');
  // Remove path and query parameters
  domain = domain.split('/')[0].split('?')[0];
  return domain.toLowerCase();
};

export const isDomainOrUrl = (text: string): boolean => {
  // Check if it contains a dot and looks like a domain
  const domainRegex = /^[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.([a-zA-Z]{2,}|[a-zA-Z]{2,}\.[a-zA-Z]{2,})$/;
  const urlRegex = /^(https?:\/\/)?([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}/;
  
  const cleanText = extractDomainFromInput(text);
  return domainRegex.test(cleanText) || urlRegex.test(text);
};

export const parseInput = (inputText: string): { domains: string[], keywords: string, companyList: string[] } => {
  // Check if this looks like a CSV list (multiple items separated by commas or newlines)
  const items = inputText.split(/[,\n]/).map(item => item.trim()).filter(item => item.length > 0);
  
  // If we have more than 5 items, treat it as a CSV list
  if (items.length > 5) {
    return {
      domains: [],
      keywords: '',
      companyList: items
    };
  }

  const domains: string[] = [];
  const keywordsList: string[] = [];

  items.forEach(item => {
    if (isDomainOrUrl(item)) {
      domains.push(extractDomainFromInput(item));
    } else {
      keywordsList.push(item);
    }
  });

  return {
    domains,
    keywords: keywordsList.join(' '),
    companyList: []
  };
}; 